import { render, staticRenderFns } from "./sensitivityPopup.vue?vue&type=template&id=60cad57c&scoped=true"
import script from "./sensitivityPopup.vue?vue&type=script&lang=js"
export * from "./sensitivityPopup.vue?vue&type=script&lang=js"
import style0 from "./sensitivityPopup.vue?vue&type=style&index=0&id=60cad57c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cad57c",
  null
  
)

export default component.exports